import { useMutation, gql } from '@apollo/client';

export const ClearSelectedItems = gql`
    mutation UpdateSelectedFiles($id: Int!, $checked: Boolean!) {
        updateMainDirectorySelectedItem(id: $id, checked: $checked)
    }
`;

interface IClearSelectedItemsVars {
    id: number;
    checked: boolean;
}

export const useUpdateMainDirectorySelectedItem = () => useMutation<boolean, IClearSelectedItemsVars>(ClearSelectedItems);
